import React from "react";
import { useNavigate } from "react-router-dom";

interface ProjectProps {
    image: string;
    title: string;
    date: string;
    description: string;
    route: string;
}

const ProjectCard: React.FC<ProjectProps> = ({ image, title, date, description, route }) => {
    const navigate = useNavigate();

    return (
    <div className="max-w-sm bg-purple rounded overflow-hidden flex flex-col h-full">
      <img className="w-full h-auto object-cover transition-transform duration-300 ease-in-out transform hover:scale-105" src={image} alt={title} />

      <div className="p-5 flex flex-col flex-1">
        <h3 className="text-white text-center text-2xl font-bold font-euro text-gray-800">{title}</h3>
        <p className="text-white text-center font-frankbook text-md">{date}</p>
        <p className="text-white text-center font-frankbook text-md lg:text-lg flex-1 my-6">{description}</p>

        <button
          onClick={() => navigate(route)}
          className="text-white bg-orange hover:bg-lightOrange font-euro w-full py-2 px-4 mt-auto"
        >
          View Work
        </button>
      </div>
    </div>
    );
};

export default ProjectCard;